import styled, { css } from 'react-emotion';
import './WidgetReset';

export const Wrapper = styled.div`
	border: 1px solid #D8D8D8;
	display: flex;
	font-family: 'Barlow', sans-serif;
	min-height: 261px;
	position: relative;

	> div {
		flex-grow: 1;
	}
	@media (max-width: 480px) {
		justify-content: center;
		align-items: center;
		text-align: center;
		margin-left: 1em;
		margin-right: 1em;
	}
`;

export const Left = styled.div`
	background: ${props => props.theme.color};
	box-sizing: border-box;
	text-align: center;
	padding: 1rem;

	@media (max-width: 759px) {
		display: none;
	}
	@media (min-width: 760px) and (max-width: 1023px) {
		flex-basis: 30%;
	}
	@media (min-width: 1024px) {
		flex-basis: 24%;
	}
`;

export const Middle = styled.div`
	box-sizing: border-box;
	padding: 1rem;

	@media (max-width: 759px) {
		flex-basis: 100%;
		padding-bottom: 25px;
	}
	@media (min-width: 760px) and (max-width: 1023px) {
		flex-basis: 70%;
	}
	@media (min-width: 1024px) {
		flex-basis: 50%;
	}
`;

export const Right = styled.div`
	background: #f2f2f2;

	@media (max-width: 1023px) {
		display: none;
	}
	@media (min-width: 1024px) {
		flex-basis: 26%;
	}
`;

export const TextCenter = styled.div`
	text-align: center;
	width: 100%;
	
	a {
		@media (max-width: 500px) {
			margin-left: auto !important;
			margin-right: auto !important;
		}
	}
`;

export const wrapperAktualne = css`
	@media (max-width: 480px) {
		min-height: unset;
		background: #f2f2f2;
	}
`;
